import { BaseWizardStep } from '../base.wizard.step';

import { ApiService } from '@nrwl/common-lib';

export class RadiusServerWizardStep extends BaseWizardStep {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addNewItemCallback: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  methodTypeSource: any;
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  constructor(apiService: ApiService, config: any, parent: any) {
    super(apiService, config, parent);
    if (this.config.def.subContent) {
      this.subContent = new RadiusServerWizardStep(apiService, config.def.subContent, this);
    }
  }
}
